import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useSubscription } from "../providers/SubscriptionProvider";
import { useThemeStore } from "../stores/themeStore";

interface DashboardBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const DashboardBackground: React.FC<DashboardBackgroundProps> = ({
  children,
  className = "",
}) => {
  const { userData } = useAuth();
  const { isPremium } = useSubscription();
  const { resolvedTheme } = useThemeStore();
  const isDark = resolvedTheme === "peakx-dark";

  const customImage = isPremium && userData?.backgroundImage;

  const gradientOverlay = isDark
    ? "linear-gradient(to bottom, rgba(34,34,34,0.5) 0%, rgba(34,34,34,0.6) 40%, rgba(34,34,34,0.8) 100%)"
    : "linear-gradient(to bottom, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.3) 30%, rgba(255,255,255,0.1) 100%)";

  return (
    <div
      className={`sm:pb-4 relative ${!customImage && !userData?.casualMode ? "dashboard-background" : ""} ${className}`}
      style={{ isolation: "isolate" }}
    >
      {customImage && (
        <div
          className="absolute inset-0 -z-10 pointer-events-none"
          style={{
            backgroundImage: `
              ${gradientOverlay},
              url("${customImage}")
            `,
            backgroundSize: "cover",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
            ...(isDark
              ? {
                  filter: "brightness(0.45) blur(1.5px)",
                  mixBlendMode: "multiply" as const,
                }
              : {}),
          }}
        />
      )}
      {children}
    </div>
  );
};

export default DashboardBackground;
